export const environment = {
  production: false,
  develop: false,
  firebase: {
    apiKey: "AIzaSyCVtN9rI-Ar2drP1kwwztKLjyAKg950qFU",
    authDomain: "utopqa.firebaseapp.com",
    databaseURL: "https://utopqa.firebaseio.com",
    projectId: "utopqa",
    storageBucket: "utopqa.appspot.com",
    messagingSenderId: "1036816231058",
    appId: "1:1036816231058:web:d71756f44df7561095144b",
    measurementId: "G-F1D6N8W9SL",
  },
  unileverApiHost: "https://apiqa.quatangunilever.vn/ugift",
  unileverSignalR: "https://apiqa.quatangunilever.vn/ugift/unileversignalhub",
  dashboardApiHost: "https://apiqa.quatangunilever.vn/adminportal",
  apiQuatangunilever: "https://apiqa.quatangunilever.vn",
  urlUserQrCode: "https://ugift-qa.quatangunilever.com",
  requestHeader: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Max-Age": "604800",
    "Access-Control-Allow-Credentials": "true",
    "Api-Version": "qa",
    "Ocp-Apim-Subscription-Key": "716a112cba2c4976a51c9d75ef0db3aa",
    CampaignId: "1000",
    TenantId: "1",
    MallId: "0",
    StoreId: "0",
    UID: "",
  },
  rootPath: "",
  isEnableBlockBrowser: true,
};
